export default __webpack_public_path__ + "static/media/comic-book.d97b4c74.webp";